import { render } from "./RegistrationDetails.vue?vue&type=template&id=f2b633c2&scoped=true"
import script from "./RegistrationDetails.vue?vue&type=script&lang=js"
export * from "./RegistrationDetails.vue?vue&type=script&lang=js"

import "@/Common/Styles/registrationSteps.scss?vue&type=style&index=0&id=f2b633c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b633c2"]])

export default __exports__